import { useCallback, useSyncExternalStore } from "react";

const getServerSnapshot = () => false;

export default function useMediaQuery(query: string) {
  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      if (typeof window === "undefined" || !window.matchMedia) return () => {};

      const mediaQueryList = window.matchMedia(query);
      if (mediaQueryList.addEventListener) {
        mediaQueryList.addEventListener("change", onStoreChange);
      } else {
        mediaQueryList.addListener(onStoreChange);
      }

      return () => {
        if (mediaQueryList.removeEventListener) {
          mediaQueryList.removeEventListener("change", onStoreChange);
        } else {
          mediaQueryList.removeListener(onStoreChange);
        }
      };
    },
    [query],
  );

  const getSnapshot = useCallback(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  }, [query]);

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
